import type { IEnv } from '../../../types/types';
import getPresentation from './presentation';

function getSettings(env: IEnv) {
  const settings = {
    uses: 'settings',
    items: {
      general: {
        items: {
          showTitles: {
            defaultValue: false,
          },
          cellNavMenu: {
            type: 'items',
            items: {
              enableNavMenu: {
                ref: 'disableNavMenu',
                type: 'boolean',
                translation: 'properties.showHoverMenu',
                defaultValue: !!env?.flags?.isEnabled?.('TLV_1804_DEFAULT_CHART_SETTINGS'),
                inverted: true,
              },
            },
          },
        },
      },
      simpleLabels: null,
    },
  };

  Object.assign(settings.items, getPresentation(env));

  return settings;
}

export default getSettings;
